import { useEffect } from "react";

const SITE_URL = "https://atelierax.ma";

const upsertMeta = (selector, attributes) => {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("meta");
        const { name, property } = attributes;
        if (name) el.setAttribute("name", name);
        if (property) el.setAttribute("property", property);
        document.head.appendChild(el);
    }
    if (attributes.content !== undefined) el.setAttribute("content", attributes.content);
};

const upsertCanonical = (href) => {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
    }
    link.setAttribute("href", href);
};

/**
 * Sets page-level SEO meta (title, description, robots, canonical) plus
 * social cards (og:title, og:description, og:url, twitter:title,
 * twitter:description) for the current route.
 * Admin routes should pass noindex: true.
 */
const usePageMeta = ({
    title,
    description,
    path = "/",
    noindex = false,
} = {}) => {
    useEffect(() => {
        if (title) {
            document.title = title;
        }
        if (description) {
            upsertMeta('meta[name="description"]', { name: "description", content: description });
        }
        upsertMeta('meta[name="robots"]', {
            name: "robots",
            content: noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1",
        });
        const canonicalPath = path.startsWith("/") ? path : `/${path}`;
        const url = `${SITE_URL}${canonicalPath === "/" ? "/" : canonicalPath}`;
        upsertCanonical(url);

        // Social cards per page (read by crawlers from the prerendered HTML).
        if (title) {
            upsertMeta('meta[property="og:title"]', { property: "og:title", content: title });
            upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
        }
        if (description) {
            upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
            upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
        }
        upsertMeta('meta[property="og:url"]', { property: "og:url", content: url });
    }, [title, description, path, noindex]);
};

export default usePageMeta;
